"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTimeOffRemoveRequest = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const TIME_OFF_REMOVE_REQUEST_QUERY = (0, graphql_tag_1.default) `
  mutation TimeOffRemoveRequest($workspace: ID!, $id: ID!) {
    timeOffRemoveRequest(workspace: $workspace, id: $id)
  }
`;
const requestTimeOffRemoveRequest = async (args) => {
    const { data, errors } = await (0, apollo_1.query)(TIME_OFF_REMOVE_REQUEST_QUERY, {
        variables: args,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.timeOffRemoveRequest;
};
exports.requestTimeOffRemoveRequest = requestTimeOffRemoveRequest;
